import styles from "./styles.module.css";

const ChartTooltipDivider = () => <div className={styles.divider}></div>;

ChartTooltipDivider.displayName = "DS.Charts.Tooltip.Divider";

export default ChartTooltipDivider;
